import React from 'react';
import {
  Icon,
  IconSize,
  IconComponentProps,
  Text,
  Button,
  ButtonAppearance,
  Box,
  ButtonSize,
  Spinner,
  SpinnerSize,
} from '@bechtel/gds';

export interface CommodityActionProps {
  disabled?: boolean;
  icon: IconComponentProps['icon'];
  iconText: string;
  onClick?: () => void;
  iconFillColor?: IconComponentProps['fillColor'];
  textFontColor?: string;
  loading?: boolean;
}

const CommodityAction: React.FC<CommodityActionProps> = ({
  disabled,
  iconText,
  onClick,
  icon,
  iconFillColor,
  textFontColor,
  loading,
}) => {
  return (
    <Box ml={{ sm: '400' }} onClick={onClick}>
      <Button appearance={ButtonAppearance.SECONDARY} size={ButtonSize.SMALL} disabled={disabled}>
        <Box ml={{ sm: '100' }} mr={{ sm: '300' }}>
          {loading && <Spinner size={SpinnerSize.SMALL} />}
          {!loading && (
            <Icon icon={icon} size={IconSize.MEDIUM} fillColor={iconFillColor ? iconFillColor : 'blue.800'} />
          )}
        </Box>
        <Text size={'300'} color={textFontColor ? textFontColor : 'grey.1000'}>
          {iconText}
        </Text>
      </Button>
    </Box>
  );
};

export default CommodityAction;
